import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { getIn } from 'formik';

import { NestedCheckboxDropDown } from '../../FilterComponents/NestedCheckboxDropdownOverlay/NestedCheckboxDropdownOverlay';

import styles from './index.module.css';

const renderDropDownComponent =
  ({ myClassName, hasValues, value, title }) =>
  ({ visible }) =>
    (
      <div
        className={classnames({
          [styles.headRow]: true,
          [myClassName]: myClassName,
          [styles.headRowActive]: visible,
          [styles.headRowDisabled]: !visible,
        })}>
        <span
          className={classnames({
            [styles.cellTitle]: true,
            [myClassName]: myClassName,
          })}>
          {hasValues && !visible ? value : title}
        </span>
        <DownOutlined
          className={classnames({
            [styles.icon]: true,
            [styles.disabled]: !visible,
          })}
        />
      </div>
    );

export const FilterNestedCheckboxListCell = ({ value, name, title, values, myClassName, ...rest }) => (
  <NestedCheckboxDropDown
    {...rest}
    values={values}
    name={name}
    title={title}
    Component={renderDropDownComponent({
      myClassName,
      value,
      hasValues: getIn(values, name)?.length > 0,
      title,
    })}
  />
);

FilterNestedCheckboxListCell.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      value: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
      children: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          value: PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
          }),
        })
      ),
    })
  ),
  name: PropTypes.string,
  title: PropTypes.string,
  values: PropTypes.object,
  myClassName: PropTypes.string,
};